export const PAGE_DESCRIPTIONS: Record<string, string> = {
  Dashboards:
    "Aggregate prediction market odds across platforms. Market intelligence and comparative odds analysis for informed decision-making.",
  Insights:
    "Institutional market insights, education, platform comparisons, and more. See what the markets agree on.",
  "Api & Data Licensing":
    "Prediction market data & APIs for research. Institutional-grade market feeds, bulk exports, and analytics.",
  Pricing:
    "Market intelligence platform. Access prediction market data, odds, and analytics for institutional and retail users.",
  "How it works":
    "Understanding prediction markets. Learn odds mechanics, compare platforms, and access institutional market intelligence.",
  Trending:
    "Hot prediction markets & market intelligence. See what's moving in prediction markets.",
  "Privacy Policy":
    "PredictionHero Privacy Policy. How we collect, use, and protect your data in prediction markets.",
  "Terms of use":
    "PredictionHero Terms of Use. Legal agreement for using our platform and prediction markets.",
  Disclaimer:
    "PredictionHero Disclaimer. Important legal information about prediction markets and forecasting risks.",
  "FIFA 2026 World Cup":
    "FIFA World Cup 2026 predictions & odds. Compare market forecasts on teams, winners, and tournament outcomes.",
  "War Index":
    "Geopolitical conflict index & predictions. Compare market odds on international events and geopolitics.",
};
